export const VEHICLE_INSURANCE_PROVIDERS = Object.freeze({
  AXLE: 'axle',
  MANUAL: 'manual',
  MEASURE_ONE: 'measure_one',
});
